import { useCallback, useEffect, useState } from "react";
import User from "../passapp-sdk/user";
import { useStore } from "./useStore";
import { SelectOption } from "../components/common/PL/Select/Select";

const userApi = new User();

/** ART dadas de alta por el admin de edificios. Mismo patrón que useInsuranceCompanies: la
 * respuesta trae `{id, name}`, así que el value es el id. */
const useArtCompanies = () => {
  const { authStore } = useStore();
  const [companies, setCompanies] = useState<SelectOption[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCompanies = useCallback(
    async (search?: string) => {
      if (!authStore.token) return;
      setLoading(true);
      try {
        const response = await userApi.getArtCompanies(authStore.token, search);
        if (response?.data) {
          const companiesArray = Array.isArray(response.data)
            ? response.data
            : Object.values(response.data);
          const options: SelectOption[] = companiesArray.map((company: any) => ({
            value: company.id,
            label: company.name,
          }));
          setCompanies(options);
        }
      } catch (err) {
        console.error("Error fetching ART companies:", err);
      } finally {
        setLoading(false);
      }
    },
    [authStore.token]
  );

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  return { companies, loading, fetchCompanies };
};

export default useArtCompanies;
